/* eslint-disable no-param-reassign  */
import 'ekko-lightbox';

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['gallery', 'thumb', 'image'];

  static values = {
    enabled: Boolean,
  }

  open(e) {
    e.preventDefault();

    if (!this.enabledValue) {
      return;
    }

    const i = parseInt(e.currentTarget.dataset.index, 10);

    $(this.galleryTargets[i]).ekkoLightbox({
      alwaysShowClose: true,
      showArrows: true,
    });
  }

  selectImage(e) {
    e.preventDefault();

    const i = parseInt(e.currentTarget.dataset.index, 10);
    this.showImage(i);
  }

  showImage(i) {
    this.imageTargets.forEach((image, x) => {
      if (i === x) {
        image.style.display = 'block';
      } else {
        image.style.display = 'none';
      }
    });

    this.thumbTargets.forEach((thumb, x) => {
      if (i === x) {
        thumb.classList.add('active');
      } else {
        thumb.classList.remove('active');
      }
    });
  }

  beforeCache() {
    // close the ligthbox
    if ($('body').hasClass('modal-open')) {
      $('.fade').removeClass('fade');
      $('.modal-dialog button.close').click();
    }

    // select first thumb:
    this.showImage(0);
  }
}
